import React, { createContext, useContext, useState, useRef } from "react";

const WorkspaceModalContext = createContext(null);

export function WorkspaceModalProvider({ children }) {
  const [isWorkspaceModalOpen, setWorkspaceModalOpen] = useState(false);
  const requestCloseRef = useRef(null);
  const value = React.useMemo(
    () => ({ isWorkspaceModalOpen, setWorkspaceModalOpen, requestCloseRef }),
    [isWorkspaceModalOpen]
  );
  return (
    <WorkspaceModalContext.Provider value={value}>
      {children}
    </WorkspaceModalContext.Provider>
  );
}

export function useWorkspaceModal() {
  const ctx = useContext(WorkspaceModalContext);
  if (!ctx) throw new Error("useWorkspaceModal must be used within WorkspaceModalProvider");
  return ctx;
}
